<template>
  <div class="app-main-inner" style="width: fit-content;">
    <div class="section">
      <el-form>
        <el-checkbox v-model="form.booking" no="booking" :disabled="readonly">{{ $t('SeaExport.Booking') }}</el-checkbox>
        <el-checkbox
          v-model="form.customs"
          no="customs"
          :disabled="readonly"
          style="margin-left: -20px;"
          @change="val=>{form.customsBroker=val?form.customsBroker:0;form.customsDeclarationType=val?form.customsDeclarationType:-1}"
        >{{ $t('SeaExport.CustomsDeclaration') }}</el-checkbox>
        <el-checkbox v-model="form.insure" :disabled="readonly" no="isInsure" style="margin-left: -20px;">{{ $t('SeaExport.InsureInfo') }} </el-checkbox>
        <el-checkbox v-if="isBookingNew && isFba" v-model="form.destinationPortService" no="destinationPortService" style="margin-left: -20px;">{{ $t('SeaExport.PortOfDestinationServices') }}</el-checkbox>
        <el-button
          v-if="viewSource==='bookingWorkspace'"
          v-permission="['button_insurance_toInsure']"
          no="Insure"
          :disabled="isEdit"
          type="primary"
          style="margin-left: 20px;"
          @click="pm.toInsure()"
        >{{ $t('SeaExport.Insure') }}</el-button>
        <span v-if="!isFba" style="margin-left: 20px;">{{ $t('CargoMsg.Cargo_BusinessType') }}</span>
        <el-radio-group v-if="!isFba" v-model="form.lob" no="lob" :disabled="readonly" style="margin-left: 10px;" @change="lobChangeHandler">
          <el-radio no="RE" label="RE">{{ $t('CargoMsg.Cargo_Export') }}</el-radio>
          <el-radio no="RI" label="RI" style="margin-left: -20px;">{{ $t('CargoMsg.Cargo_JobTypeImport') }}</el-radio>
        </el-radio-group>
        <span v-if="!!templateName" class="blue" style="float: right;margin-right: 30px;line-height: 28px;padding: 0 5px;white-space: nowrap;">{{ $t('CargoMsg.Cargo_SopTemplate') }}: {{ templateName }}</span>
      </el-form>
    </div>
    <tab-booking-master-UICustom-layout :element-blocks="elementBlocks" :disabled="readonly">
      <el-form-item v-if="elementDict.jobNo.masterVisible" slot="jobNo">
        <line-label slot="label" :class="elementDict.jobNo.isRequire ? 'blue' : ''" :label="elementDict.jobNo.label" />
        <el-input :value="form.jobNo" no="jobNo" :disabled="true" />
      </el-form-item>
      <template v-if="isZY">
        <el-form-item slot="saleProductCode">
          <span slot="label" class="blue">{{ $t('SeaExport.AllowSaleProduct') }}</span>
          <cargo-advance-select
            :select-type="selectTypeNames.basic_data_AllowSaleProduct"
            filterable
            no="allowSaleProduct"
            clearable
            :data-filter-function="p => {
              if (!p.statusEnabled) {
                return false
              }
              return isFba ? p.fbaRailway : p.railwayFreight
            }"
            :default-value="form.saleProductCode || ''"
            @parentCallBack="p => {form.saleProductCode = p.value}"
          />
        </el-form-item>
        <el-form-item slot="fullOrInside">
          <span slot="label" class="blue">{{ $t('SeaExport.FullOrInside') }}</span>
          <cargo-advance-select
            :select-type="selectTypeNames.local_cache_FullOrInside$FULL_OR_INSIDE"
            no="fullOrInside"
            clearable
            :default-value="form.fullOrInside || ''"
            @parentCallBack="p => {form.fullOrInside = p.value}"
          />
        </el-form-item>
      </template>
      <el-form-item v-if="elementDict.containerLoadType.masterVisible" slot="containerLoadType">
        <line-label slot="label" :class="elementDict.containerLoadType.isRequire ? 'blue' : ''" :label="elementDict.containerLoadType.label" />
        <el-select
          v-model="form.containerLoadType"
          no="containerLoadType"
          @change="pm.selectDefaultCutomJobType();onContainerLoadTypeChange()"
        >
          <el-option
            v-for="(item,index) in containerLoadTypes"
            :key="index"
            :label="item.chineseName"
            :value="item.code"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="elementDict.cargoType.masterVisible" slot="cargoType">
        <line-label slot="label" :class="elementDict.cargoType.isRequire ? 'blue' : ''" :label="elementDict.cargoType.label" />
        <cargo-advance-select
          no="cargoType"
          :select-type="selectTypeNames.basic_data_CargoType"
          :headers="[$t('Partners.chineseName')]"
          :fields="['chineseName']"
          :filter-field-names="['chineseName']"
          :method-params="{sea:true}"
          filterable
          :clearable="false"
          :default-value="form.cargoType"
          @parentCallBack="p=>{form.cargoType=p.value;onCargoTypeChagne()}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.transportType.masterVisible" slot="transportType">
        <line-label slot="label" :class="elementDict.transportType.isRequire ? 'blue' : ''" :label="elementDict.transportType.label" />
        <cargo-advance-select
          no="transportType"
          :select-type="selectTypeNames.basic_data_TransportationType"
          :method-params="{companyLob:'railwayExport',transportType:true,active:true}"
          filterable
          :default-value="form.transportType"
          :tag-name="this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName'"
          :tag-value="'code'"
          :placeholder="$t('SeaExport.RequiredItem')"
          @parentCallBack="p=>{form.transportType=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.fullHalf.masterVisible" slot="fullHalf">
        <line-label slot="label" :class="elementDict.fullHalf.isRequire ? 'blue' : ''" :label="elementDict.fullHalf.label" />
        <cargo-advance-select
          no="fullHalf"
          :select-type="selectTypeNames.local_cache_FullHalf"
          filterable
          :default-value="form.fullHalf"
          @parentCallBack="p=>{form.fullHalf=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.transportLine.masterVisible" slot="transportLine">
        <line-label slot="label" :class="elementDict.transportLine.isRequire ? 'blue' : ''" :label="elementDict.transportLine.label" />
        <cargo-advance-select
          no="transportLine"
          :select-type="selectTypeNames.basic_data_RailwayLine"
          filterable
          :default-value="form.transportLine"
          tag-name="name"
          @parentCallBack="p=>{form.transportLine=p.value;pm.refreshPlanner(p.value)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.etd.masterVisible" slot="etd">
        <line-label slot="label" :class="elementDict.etd.isRequire ? 'blue' : ''" :label="elementDict.etd.label" />
        <div style="display: flex">
          <el-date-picker
            v-model="form.etd"
            no="etd"
            class="departure-date-picker"
            type="date"
            value-format="yyyy-MM-dd"
            style="flex: 1; width:140px; margin-right: 5px"
            @input="etdChange"
          />
          <span>{{ form.sailingDay|filterWeek }}</span>
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.eta.masterVisible" slot="eta">
        <line-label slot="label" :class="elementDict.eta.isRequire ? 'blue' : ''" :label="elementDict.eta.label" />
        <div style="display: flex">
          <el-date-picker
            v-model="form.eta"
            no="eta"
            type="date"
            value-format="yyyy-MM-dd"
            style="flex: 1; width:140px; margin-right: 5px"
            @input="etaChange"
          />
          <span>{{ form.etaSailingDay|filterWeek }}</span>
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.atd.masterVisible" slot="atd">
        <line-label slot="label" :class="elementDict.atd.isRequire ? 'blue' : ''" :label="elementDict.atd.label" />
        <div style="display: flex">
          <el-date-picker
            v-model="form.atd"
            no="atd"
            type="date"
            value-format="yyyy-MM-dd"
            clearable
            style="flex: 1; width:140px; margin-right: 5px"
            @input="atdChange"
          />
          <span>{{ form.atdSailingDay|filterWeek }}</span>
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.ata.masterVisible" slot="ata">
        <line-label slot="label" :class="elementDict.ata.isRequire ? 'blue' : ''" :label="elementDict.ata.label" />
        <div style="display: flex">
          <el-date-picker
            v-model="form.ata"
            no="ata"
            type="date"
            value-format="yyyy-MM-dd"
            clearable
            style="flex: 1; width:140px; margin-right: 5px"
            @input="ataChange"
          />
          <span>{{ form.ataSailingDay|filterWeek }}</span>
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.customsDate.masterVisible" slot="customsDate">
        <line-label slot="label" :class="elementDict.customsDate.isRequire ? 'blue' : ''" :label="elementDict.customsDate.label" />
        <el-date-picker
          v-model="form.customsDate"
          no="customsDate"
          type="date"
          value-format="yyyy-MM-dd"
          style="width:100%"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.departureStation.masterVisible" slot="departureStation">
        <line-label slot="label" :class="elementDict.departureStation.isRequire ? 'blue' : ''" :label="elementDict.departureStation.label" />
        <div style="display: flex">
          <cargo-advance-select
            no="departureStation"
            :select-type="selectTypeNames.basic_data_RailwayStation"
            filterable
            :default-value="form.departureStation"
            @parentCallBack="p=>{form.departureStation=p.value;onDepartureStationChange()}"
          />
          <el-checkbox
            v-model="form.transfer"
            no="transfer"
            style="width:80px; padding-left: 5px;"
          >{{ $t('SeaExport.Transit') }}</el-checkbox>
        </div>
      </el-form-item>
      <el-form-item
        v-show="form.transfer && elementDict.transferStation.masterVisible"
        slot="transferStation"
      >
        <line-label slot="label" :class="elementDict.transferStation.isRequire ? 'blue' : ''" :label="elementDict.transferStation.label" />
        <cargo-advance-select
          no="transferStation"
          :select-type="selectTypeNames.basic_data_RailwayStation"
          filterable
          :default-value="form.transferStation"
          @parentCallBack="p=>{form.transferStation=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.transitStation.masterVisible" slot="transitStation">
        <line-label slot="label" :class="elementDict.transitStation.isRequire ? 'blue' : ''" :label="elementDict.transitStation.label" />
        <cargo-advance-select
          no="transitStation"
          :select-type="selectTypeNames.basic_data_RailwayStation"
          filterable
          :default-value="form.transitStation"
          @parentCallBack="p=>{form.transitStation=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.destinationStation.masterVisible" slot="destinationStation">
        <line-label slot="label" :class="elementDict.destinationStation.isRequire ? 'blue' : ''" :label="elementDict.destinationStation.label" />
        <cargo-advance-select
          no="destinationStation"
          :select-type="selectTypeNames.basic_data_RailwayStation"
          filterable
          :default-value="form.destinationStation"
          @parentCallBack="destinationStationChange"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.destinationCountry.masterVisible" slot="destinationCountry">
        <line-label slot="label" :class="elementDict.destinationCountry.isRequire ? 'blue' : ''" :label="elementDict.destinationCountry.label" />
        <cargo-advance-select
          no="destinationCountry"
          :select-type="selectTypeNames.basic_data_Country"
          filterable
          :default-value="form.destinationCountry"
          @parentCallBack="p=>{form.destinationCountry=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.cargoSource.masterVisible" slot="cargoSource">
        <line-label slot="label" :class="elementDict.cargoSource.isRequire ? 'blue' : ''" :label="elementDict.cargoSource.label" />
        <el-select
          v-model="form.cargoSource"
          no="cargoSource"
          :placeholder="$t('SeaExport.PleaseSelect')"
          :clearable="false"
          size="mini"
          @change="form.designationAgent=0;pm.cargoSourceChange()"
        >
          <el-option
            v-for="(item,index) in CARGO_SOURCES"
            :key="index"
            :label="item.chineseName"
            :value="item.code"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="elementDict.customJobType.masterVisible" slot="customJobType">
        <line-label slot="label" :class="elementDict.customJobType.isRequire ? 'blue' : ''" :label="elementDict.customJobType.label" />
        <cargo-advance-select
          v-if="form.lob==='RE'"
          key="1"
          ref="customJobType"
          no="customJobType"
          :select-type="selectTypeNames.basic_data_CutomJobType"
          filterable
          :tag-name="isZh?'name':'englishName'"
          :static-options="customJobTypeList"
          :method-params="{type:form.lob}"
          :default-value="form.customJobType"
          @parentCallBack="p=>{form.customJobType=p.value;onCustomJobTypeChange()}"
        />
        <cargo-advance-select
          v-else-if="form.lob==='RI'"
          key="2"
          ref="customJobType"
          no="customJobType"
          :select-type="selectTypeNames.basic_data_CutomJobType"
          filterable
          :tag-name="isZh?'name':'englishName'"
          :method-params="{type:form.lob}"
          :static-options="customJobTypeList"
          :default-value="form.customJobType"
          @parentCallBack="p=>{form.customJobType=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="form.customJobType && secondaryCustomJobTypeList.length > 0 && elementDict.secondaryCustomJobType.masterVisible" slot="secondaryCustomJobType">
        <line-label slot="label" :class="elementDict.secondaryCustomJobType.isRequire ? 'blue' : ''" :label="elementDict.secondaryCustomJobType.label" />
        <cargo-advance-select
          ref="secondaryCustomJobType"
          no="secondaryCustomJobType"
          :select-type="selectTypeNames.basic_data_CutomJobType"
          filterable
          :cache="false"
          :default-value="form.secondaryCustomJobType"
          :tag-name="isZh?'name':'englishName'"
          :static-options="secondaryCustomJobTypeList"
          @parentCallBack="p=>{form.secondaryCustomJobType=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.bookingAgent.masterVisible" slot="bookingAgent">
        <line-label slot="label" :class="elementDict.bookingAgent.isRequire ? 'blue' : ''" :label="elementDict.bookingAgent.label" />
        <cargo-advance-select
          no="bookingAgent"
          :select-type="selectTypeNames.basic_data_Company"
          :method-params="{companyLob:'railwayExport',bookingAgent:true,active:true}"
          filterable
          :default-value="form.bookingAgent||''"
          @parentCallBack="p=>{form.bookingAgent=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.portAgent.masterVisible" slot="portAgent">
        <line-label slot="label" :class="elementDict.portAgent.isRequire ? 'blue' : ''" :label="elementDict.portAgent.label" />
        <cargo-advance-select
          no="portAgent"
          :select-type="selectTypeNames.basic_data_Company"
          :method-params="{companyLob:'railwayExport',portAgent:true,active:true}"
          filterable
          :default-value="form.portAgent||''"
          @parentCallBack="p=>{form.portAgent=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.forwardingAgent.masterVisible" slot="forwardingAgent">
        <line-label slot="label" :class="elementDict.forwardingAgent.isRequire ? 'blue' : ''" :label="elementDict.forwardingAgent.label" />
        <cargo-advance-select
          no="forwardingAgent"
          :select-type="selectTypeNames.basic_data_Company"
          :method-params="{companyLob:'railwayExport',forwardingAgent:true,active:true}"
          filterable
          :default-value="form.forwardingAgent||''"
          @parentCallBack="p=>{form.forwardingAgent=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.destinationAgent.masterVisible" slot="destinationAgent">
        <line-label slot="label" :class="elementDict.destinationAgent.isRequire ? 'blue' : ''" :label="elementDict.destinationAgent.label" />
        <el-tooltip
          :content="destinationAgentTip"
          :disabled="!showDestinationAgentWarning"
          placement="right-end"
        >
          <cargo-company-select
            ref="destinationAgent"
            no="destinationAgent"
            :method-params="{overseaAgent:true,active:true,companyLob:'railwayExport'}"
            :check-credit="true"
            :job="form"
            :default-value="form.destinationAgent||''"
            filterable
            :headers="[$t('Partners.englishName')]"
            :fields="['englishName']"
            tag-name="englishName"

            @change="p=>{pm.txtDestinationAgentChangeHandler(p)}"
          />
        </el-tooltip>
      </el-form-item>
      <el-form-item
        v-show="form.cargoSource==='NC' && elementDict.designationAgent.masterVisible"
        slot="designationAgent"
      >
        <line-label slot="label" :class="elementDict.designationAgent.isRequire ? 'blue' : ''" :label="elementDict.designationAgent.label" />
        <el-tooltip
          :content="designationAgentTip"
          :disabled="!showDesignationAgentWarning"
          placement="right-end"
        >
          <cargo-company-select
            no="designationAgent"
            class="designation-agent-selector"
            popper-class="designation-agent-selector-popper"
            :disabled="!designationAgentEnabled"
            :method-params="{designationAgent:true,active:true}"
            :check-credit="true"
            :job="form"
            :default-value="form.designationAgent||''"
            filterable
            :headers="[$t('Partners.englishName')]"
            :fields="['englishName']"
            tag-name="englishName"
            style="width:190px;"
            @change="p=>{pm.txtDesignationAgentChangeHandler(p)}"
          />
        </el-tooltip>
      </el-form-item>
      <el-form-item v-if="elementDict.transportSource.masterVisible" slot="transportSource">
        <line-label slot="label" :class="elementDict.transportSource.isRequire ? 'blue' : ''" :label="elementDict.transportSource.label" />
        <cargo-advance-select
          filterable
          :select-type="selectTypeNames.basic_data_TransportSource"
          no="transportSource"
          :default-value="form.transportSource"
          :cache="false"
          tag-value="code"
          placeholder=" "
          @parentCallBack="item=>form.transportSource=item.value"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.statisticArea.masterVisible" slot="statisticArea">
        <line-label slot="label" :class="elementDict.statisticArea.isRequire ? 'blue' : ''" :label="elementDict.statisticArea.label" />
        <cargo-advance-select
          filterable
          :select-type="selectTypeNames.basic_data_StatisticArea"
          no="statisticArea"
          :default-value="form.statisticArea"
          :cache="false"
          tag-value="code"
          placeholder=" "
          @parentCallBack="item=>form.statisticArea=item.value"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.localService.masterVisible" slot="localService">
        <line-label slot="label" :class="elementDict.localService.isRequire ? 'blue' : ''" :label="elementDict.localService.label" />
        <el-checkbox
          v-model="form.warehousing"
          no="warehousing"
          @change="pm.loadingTermChange('warehousing')"
        >{{ $t('SeaExport.WarehouseLoadingStorage') }}</el-checkbox>
        <el-checkbox
          v-model="form.landTransportation"
          no="landTransportation"
          @change="pm.loadingTermChange('landTransportation')"
        >{{ $t('SeaExport.DoorLoadingDelivery') }}</el-checkbox>
        <el-checkbox
          v-model="form.selfDeliver"
          no="selfDeliver"
        >{{ $t('SeaExport.NotResponsibleForTruckingAndLoading') }}</el-checkbox>
      </el-form-item>
      <el-form-item v-if="elementDict.paymentMethod.masterVisible" slot="paymentMethod">
        <line-label slot="label" :class="elementDict.paymentMethod.isRequire ? 'blue' : ''" :label="elementDict.paymentMethod.label" />
        <cargo-advance-select
          no="paymentMethod"
          :select-type="selectTypeNames.basic_data_PaymentMethod"
          :method-params="{companyLob:'railwayExport',paymentMethod:true,active:true}"
          filterable
          :default-value="form.paymentMethod"
          :tag-name="this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName'"
          :tag-value="'code'"
          :placeholder="$t('SeaExport.RequiredItem')"
          @parentCallBack="p=>{form.paymentMethod=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.mbl.masterVisible" slot="mbl">
        <line-label slot="label" :class="elementDict.mbl.isRequire ? 'blue' : ''" :label="elementDict.mbl.label" />
        <el-input v-model="form.mbl" no="mbl" />
      </el-form-item>
      <el-form-item v-if="elementDict.vessel.masterVisible" slot="vessel">
        <line-label slot="label" :class="elementDict.vessel.isRequire ? 'blue' : ''" :label="elementDict.vessel.label" />
        <el-input v-model="form.vessel" no="vessel" />
      </el-form-item>
      <el-form-item v-if="elementDict.voyageFlight.masterVisible" slot="voyageFlight">
        <line-label slot="label" :class="elementDict.voyageFlight.isRequire ? 'blue' : ''" :label="elementDict.voyageFlight.label" />
        <el-input v-model="form.voyageFlight" no="voyageFlight" />
      </el-form-item>
      <el-form-item v-if="elementDict.customerRefNo.masterVisible" slot="customerRefNo">
        <line-label slot="label" :class="elementDict.customerRefNo.isRequire ? 'blue' : ''" :label="elementDict.customerRefNo.label" />
        <cargo-input v-model="form.customerRefNo" no="customerRefNo" :trim="true" />
      </el-form-item>
      <el-form-item v-if="elementDict.poNo.masterVisible" slot="poNo" :class="poNoRed?'poNoClass':''">
        <line-label slot="label" :class="elementDict.poNo.isRequire ? 'blue' : ''" :label="elementDict.poNo.label" />
        <el-input v-model="form.poNo" no="poNo" />
      </el-form-item>
      <el-form-item v-if="elementDict.customsBroker.masterVisible" slot="customsBroker">
        <line-label slot="label" :class="elementDict.customsBroker.isRequire ? 'blue' : ''" :label="elementDict.customsBroker.label" />
        <cargo-advance-select
          no="customsBroker"
          :disabled="!customsBrokerEnabled"
          :method-params="{customsBroker:true}"
          :select-type="selectTypeNames.basic_data_Company"
          :data-filter-function="customsBrokerFilter"
          filterable
          :default-value="form.customsBroker||''"
          :placeholder="form.customs?$t('CargoMsg.Cargo_keyWordsTip'):$t('SeaExport.PleaseTickCustomsDeclarationOption')"
          @parentCallBack="p=>{pm.customsBrokerChangeHandler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.customClaim.masterVisible" slot="customClaim">
        <line-label slot="label" :class="elementDict.customClaim.isRequire ? 'blue' : ''" :label="elementDict.customClaim.label" />
        <cargo-advance-select
          no="customsMethod"
          :disabled="!customsBrokerEnabled"
          :select-type="selectTypeNames.basic_data_CustomsMode"
          :method-params="{serviceType:2}"
          tag-value="serialNum"
          filterable
          :default-value="form.customClaim"
          @parentCallBack="p=>{form.customClaim=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.customsDeclarationType.masterVisible" slot="customsDeclarationType">
        <line-label slot="label" :class="elementDict.customsDeclarationType.isRequire ? 'blue' : ''" :label="elementDict.customsDeclarationType.label" />
        <cargo-advance-select
          no="customsDeclarationType"
          :disabled="!customsBrokerEnabled"
          :select-type="selectTypeNames.basic_data_CustomsDeclarationType"
          filterable
          :default-value="form.customsDeclarationType===-1?'':form.customsDeclarationType"
          :placeholder="$t('CargoMsg.Cargo_keyWordsTip')"
          @parentCallBack="p=>{form.customsDeclarationType=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.tradeTerm.masterVisible" slot="tradeTerm">
        <line-label slot="label" :class="elementDict.tradeTerm.isRequire ? 'blue' : ''" :label="elementDict.tradeTerm.label" />
        <cargo-advance-select
          no="tradeTerm"
          filterable
          :select-type="selectTypeNames.basic_data_TradeTerm"
          callback-method-type="value"
          :default-value="form.tradeTerm"
          :callback-params="{key:'tradeTerm'}"
          @parentCallBack="p=>{form.tradeTerm=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.incoTerm.masterVisible" slot="incoTerm">
        <line-label slot="label" :class="elementDict.incoTerm.isRequire ? 'blue' : ''" :label="elementDict.incoTerm.label" />
        <cargo-advance-select
          no="incoTerm"
          filterable
          :clearable="false"
          :select-type="selectTypeNames.basic_data_IncoTerm"
          callback-method-type="value"
          :default-value="form.incoTerm"
          :callback-params="{key:'incoTerm'}"
          placeholder=" "
          @parentCallBack="p=>{form.incoTerm=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.carryingCmp.masterVisible" slot="carryingCmp">
        <line-label slot="label" :class="elementDict.carryingCmp.isRequire ? 'blue' : ''" :label="elementDict.carryingCmp.label" />
        <cargo-company-select
          no="carryingCmp"
          :disabled="!form.landTransportation"
          :method-params="{truckCmp:true,active:true}"
          :default-value="form.carryingCmp||''"
          :placeholder="form.landTransportation?$t('CargoMsg.Cargo_keyWordsTip'):$t('SeaExport.PleaseTickDoorLoadingDeliveryOption')"
          @change="p=>{pm.carryingCmpChangeHandler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.freightTerm.masterVisible" slot="freightTerm">
        <line-label slot="label" :class="elementDict.freightTerm.isRequire ? 'blue' : ''" :label="elementDict.freightTerm.label" />
        <cargo-advance-select
          no="freightTerm"
          :select-type="selectTypeNames.basic_data_ShippingTerm"
          filterable
          :clearable="false"
          :default-value="form.freightTerm"
          @parentCallBack="p=>{form.freightTerm=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.warehouseCmp.masterVisible" slot="warehouseCmp">
        <line-label slot="label" :class="elementDict.warehouseCmp.isRequire ? 'blue' : ''" :label="elementDict.warehouseCmp.label" />
        <cargo-company-select
          no="warehouseCmp"
          :disabled="!warehouseEabled"
          :method-params="{warehouse:true,active:true}"
          :default-value="form.warehouseCmp||''"
          :placeholder="form.warehousing?$t('CargoMsg.Cargo_keyWordsTip'):$t('SeaExport.PleaseSelectWarehouse')"
          @change="p=>{pm.warehouseCmpChangeHandler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="openWarehouse && elementDict.warehouseName.masterVisible" slot="warehouseName">
        <line-label slot="label" :class="elementDict.warehouseName.isRequire ? 'blue' : ''" :label="elementDict.warehouseName.label" />
        <el-select
          ref="warehouseName"
          v-model="form.warehouseName"
          no="warehouseName"
          :disabled="!warehouseEabled||!form.warehouseCmp"
          :allow-create="true"
          filterable
          :clearable="true"
          @change="warehouseNameChangeHandler"
        >
          <el-option
            v-for="(item,index) in warehouseNameList"
            :key="index"
            :label="item.warehouseName"
            :value="item.warehouseName"
          />
        </el-select>
      </el-form-item>
      <template v-if="elementDict.diffPlacesCollaborate.slaveVisible" slot="diffPlacesCollaborate">
        <el-checkbox
          v-model="form.diffPlacesCollaborate"
          no="diffPlacesCollaborate"
        >{{ $t('RailwayExport.isDiffPlacesCollaborate') }}</el-checkbox>
        <el-form-item :label="$t('RailwayExport.loadingPlaceCompany')">
          <cargo-company-select
            no="loadingPlaceCompany"
            :method-params="{companyLob:'railwayExport',loadingPlaceCompany:true,active:true}"
            :check-credit="true"
            :job="form"
            :tooltip="true"
            tooltip-tag-name="englishName"
            :default-value="form.loadingPlaceCompany||''"
            @change="p=>{form.loadingPlaceCompany=p.value}"
          />
        </el-form-item>
        <el-form-item :label="$t('RailwayExport.signBillPlaceCompany')">
          <cargo-company-select
            no="signBillPlaceCompany"
            :method-params="{companyLob:'railwayExport',signBillPlaceCompany:true,active:true}"
            :check-credit="true"
            :job="form"
            :tooltip="true"
            tooltip-tag-name="englishName"
            :default-value="form.signBillPlaceCompany||''"
            @change="p=>{form.signBillPlaceCompany=p.value}"
          />
        </el-form-item>
      </template>
      <template v-if="elementDict.fullShipment.slaveVisible" slot="fullShipment">
        <el-checkbox v-model="form.fullShipment">{{ $t('RailwayExport.isFullShipment') }}</el-checkbox>
        <el-form-item :label="$t('RailwayExport.dischargePortCompany')">
          <cargo-company-select
            no="dischargePortCompany"
            :method-params="{companyLob:'railwayExport',dischargePortCompany:true,active:true}"
            :check-credit="true"
            :job="form"
            :tooltip="true"
            tooltip-tag-name="englishName"
            :default-value="form.dischargePortCompany||''"
            @change="p=>{form.dischargePortCompany=p.value}"
          />
        </el-form-item>
        <el-form-item :label="$t('RailwayExport.destinationPortCompany')">
          <cargo-company-select
            no="destinationPortCompany"
            :method-params="{companyLob:'railwayExport',destinationPortCompany:true,active:true}"
            :check-credit="true"
            :job="form"
            :tooltip="true"
            tooltip-tag-name="englishName"
            :default-value="form.destinationPortCompany||''"
            @change="p=>{form.destinationPortCompany=p.value}"
          />
        </el-form-item>
      </template>
      <el-form-item v-if="elementDict.seaEq.slaveVisible" slot="seaEq" label-width="0" class="auto-width">
        <booking-sea-eq-data-grid
          :value="seaEqList"
          :container-load-type="form.containerLoadType"
          :hide-soc="true"
          :is-edit="isEdit"
          :job="form"
          style="width:100%"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.quantityConsignActual.masterVisible" slot="quantityConsignActual">
        <line-label slot="label" :class="elementDict.quantityConsignActual.isRequire ? 'blue' : ''" :label="elementDict.quantityConsignActual.label" />
        <div style="display: flex">
          <auto-number-input
            v-model="form.quantityContract"
            no="quantityContract"
            :precision="0"
            :min="0"
            @change="SEUtils.changeQWCRule(()=>{form.quantityActual=form.quantityContract})"
          />
          <span style="padding:0 2px;">/</span>
          <auto-number-input
            v-model="form.quantityActual"
            no="quantityActual"
            :precision="0"
            :min="0"
            @change="SEUtils.changeQWCRule(null,()=>{form.quantityContract=form.quantityActual})"
          />
          <span>PCS</span>
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.weightConsignActual.masterVisible" slot="weightConsignActual">
        <line-label slot="label" :class="elementDict.weightConsignActual.isRequire ? 'blue' : ''" :label="elementDict.weightConsignActual.label" />
        <div style="display: flex">
          <auto-number-input
            v-model="form.weightContract"
            no="weightContract"
            :precision="3"
            :min="0"
            @change="weightContractChange"
          />
          <span style="padding:0 2px;">/</span>
          <auto-number-input
            v-model="form.weightActual"
            no="weightActual"
            :precision="3"
            :min="0"
            @change="weightActualChange"
          />
          <span>KGS</span>
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.cubageConsignActual.masterVisible" slot="cubageConsignActual">
        <line-label slot="label" :class="elementDict.cubageConsignActual.isRequire ? 'blue' : ''" :label="elementDict.cubageConsignActual.label" />
        <div style="display: flex">
          <auto-number-input
            v-model="form.cubageContract"
            no="cubageContract"
            :precision="3"
            :disabled="!cubageActualEnabled"
            :min="0"
            @change="cubageContractChange"
          />
          <span style="padding:0 2px;">/</span>
          <auto-number-input
            ref="cubageActual"
            v-model="form.cubageActual"
            no="cubageActual"
            :precision="3"
            :min="0"
            @change="cubageActualChange"
          />
          <span>CBM</span>
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.packing.masterVisible" slot="packing">
        <line-label slot="label" :class="elementDict.packing.isRequire ? 'blue' : ''" :label="elementDict.packing.label" />
        <cargo-packing-select
          ref="packing"
          no="packing"
          :default-value="form.packing"
          style="width:100%;"
          @change="p=>{form.packing=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.cargoChineseName.masterVisible" slot="cargoChineseName">
        <div slot="label">
          <span :class="elementDict.cargoChineseName.isRequire ? 'blue' : ''">{{ elementDict.cargoChineseName.label }}</span>
          <el-button
            v-show="isEdit"
            no="MergingTickets"
            type="primary"
            @click="pm.mergeLclCargoDocInfo('cargoChineseName', form)"
          >{{ $t('SeaExport.MergingTickets') }}</el-button>
        </div>
        <cargo-rich-textarea
          v-model="form.cargoChineseName"
          :show-count="true"
          no="cargoChineseName"
          :disabled="readonly"
          :auto-half-word="false"
          :text-chars="0"
          style="height: 70px;min-height: 70px;"
          @dblclick.native="showAdvanceTextDialog($t('SeaExport.ChineseDescriptionOfGoods'),form.cargoChineseName,true,val=>{form.cargoChineseName=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.cargoEnglishName.masterVisible" slot="cargoEnglishName">
        <div slot="label">
          <span :class="elementDict.cargoEnglishName.isRequire ? 'blue' : ''">{{ elementDict.cargoEnglishName.label }}</span>
          <el-button
            v-show="isEdit"
            no="MergingTickets2"
            type="primary"
            @click="pm.mergeLclCargoDocInfo('cargoEnglishName', form)"
          >{{ $t('SeaExport.MergingTickets') }}</el-button>
        </div>
        <cargo-rich-textarea
          v-model="form.cargoEnglishName"
          :show-count="true"
          no="cargoEnglishName"
          :disabled="readonly"
          :text-chars="0"
          :auto-uppercase="isUppercaseByConfig"
          style="height: 70px;min-height: 70px;"
          @dblclick.native="showAdvanceTextDialog($t('SeaExport.EnglishDescriptionOfGoods'),form.cargoEnglishName,isUppercaseByConfig,val=>{form.cargoEnglishName=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.mark.masterVisible" slot="mark">
        <div slot="label">
          <span :class="elementDict.mark.isRequire ? 'blue' : ''">{{ elementDict.mark.label }}</span>
          <el-button
            v-show="isEdit"
            no="MergingTickets3"
            type="primary"
            @click="pm.mergeLclCargoDocInfo('mark', form)"
          >{{ $t('SeaExport.MergingTickets') }}</el-button>
        </div>
        <cargo-rich-textarea
          v-model="form.mark"
          :show-count="true"
          no="mark"
          :disabled="readonly"
          :text-chars="0"
          :auto-uppercase="isUppercaseByConfig"
          style="height: 70px;min-height: 70px;"
          @dblclick.native="showAdvanceTextDialog($t('SeaExport.Marks'),form.mark,isUppercaseByConfig,val=>{form.mark=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.txtSalesOffice.masterVisible" slot="txtSalesOffice">
        <line-label slot="label" :class="elementDict.txtSalesOffice.isRequire ? 'blue' : ''" :label="elementDict.txtSalesOffice.label" />
        <el-input :value="txtSalesOffice" no="txtSalesOffice" :disabled="true" />
      </el-form-item>
      <el-form-item v-if="elementDict.sales.masterVisible" slot="sales">
        <line-label slot="label" :class="elementDict.sales.isRequire ? 'blue' : ''" :label="elementDict.sales.label" />
        <cargo-user-select
          ref="sales"
          no="sales"
          :disbled="!canChangeSalesOfJob||pm.isWithinCloseAccountDate"
          :method-params="{officeId:salesOfficeCheck?$store.getters.currentOfficeId:'',category:'role',shape:'sales'}"
          :default-value="form.sales||''"
          :merge-load="true"
          @change="p=>{pm.txtSalesChangeHandler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.cargoSalesId.masterVisible" slot="cargoSalesId">
        <line-label slot="label" :class="elementDict.cargoSalesId.isRequire ? 'blue' : ''" :label="elementDict.cargoSalesId.label" />
        <cargo-user-select
          no="cargoSalesId"
          :method-params="{category:'role',shape:'salesOfGoods'}"
          :default-value="form.cargoSalesId||''"
          :merge-load="true"
          @change="p=>{form.cargoSalesId=p.value;pm.cargoSalesChargeHandler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.salesDepartment.masterVisible" slot="salesDepartment">
        <line-label slot="label" :class="elementDict.salesDepartment.isRequire ? 'blue' : ''" :label="elementDict.salesDepartment.label" />
        <cargo-department-new-select
          no="salesOffice"
          :disabled="!form.sales"
          :enables="true"
          :sales-id="Number(form.sales)"
          :office-id="form.salesOffice"
          :department-id="Number(form.salesDepartment)"
          @change="p=>{pm.departmentChargeHandler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.opOffice.masterVisible" slot="opOffice">
        <line-label slot="label" :class="elementDict.opOffice.isRequire ? 'blue' : ''" :label="elementDict.opOffice.label" />
        <cargo-office-select
          no="opOffice"
          :disabled="(!isRegionalCommission && pm.isEntrustOrder(true)) || opOfficeDisabled"
          :is-regional-commission="isRegionalCommission"
          :office-id="Number(form.opOffice)"
          @change="p=>{form.opOffice=p.value;form.opDepartment=0;opOfficeChargeHandler()}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.opDepartment.masterVisible" slot="opDepartment">
        <line-label slot="label" :class="elementDict.opDepartment.isRequire ? 'blue' : ''" :label="elementDict.opDepartment.label" />
        <cargo-department-select
          no="opDepartment"
          :disabled="pm.isWithinCloseAccountDate"
          :office-id="Number(form.opOffice)"
          :enables="true"
          :department-id="Number(form.opDepartment)"
          @change="p=>{form.opDepartment=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.op.masterVisible" slot="op">
        <line-label slot="label" :class="elementDict.op.isRequire ? 'blue' : ''" :label="elementDict.op.label" />
        <cargo-user-select
          no="op"
          :disabled="!opEabled"
          :method-params="{officeId:form.opOffice,category:'role',shape:'op'}"
          :default-value="form.op||''"
          :merge-load="true"
          @change="p=>{pm.txtOPChangeHandler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.csrOffice.masterVisible" slot="csrOffice">
        <line-label slot="label" :class="elementDict.csrOffice.isRequire ? 'blue' : ''" :label="elementDict.csrOffice.label" />
        <cargo-office-select
          no="csrOffice"
          :disabled="true"
          :office-id="Number(form.csrOffice)"
          @change="p=>{form.csrOffice=p.value;form.csrDepartment=0}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.csrDepartment.masterVisible" slot="csrDepartment">
        <line-label slot="label" :class="elementDict.csrDepartment.isRequire ? 'blue' : ''" :label="elementDict.csrDepartment.label" />
        <cargo-department-select
          no="csrDepartment"
          :office-id="Number(form.csrOffice)"
          :enables="true"
          :department-id="Number(form.csrDepartment)"
          @change="p=>{form.csrDepartment=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.csr.masterVisible" slot="csr">
        <line-label slot="label" :class="elementDict.csr.isRequire ? 'blue' : ''" :label="elementDict.csr.label" />
        <cargo-user-select
          no="csr"
          :method-params="{officeId:pm.isEntrustOrder||fom.salesOffice===1?form.opOffice:form.salesOffice,category:'role',shape:'csr'}"
          :default-value="form.csr||''"
          :merge-load="true"
          @change="p=>{pm.csrChangeHandler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.siteOP.masterVisible" slot="siteOP">
        <line-label slot="label" :class="elementDict.siteOP.isRequire ? 'blue' : ''" :label="elementDict.siteOP.label" />
        <cargo-user-select
          :method-params="{officeId:form.opOffice,category:'role',shape:'siteOp'}"
          :default-value="form.siteOP||''"
          @change="p=>{JobUtils.siteOpChangeHandler(form, p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.overseaOp.masterVisible" slot="overseaOp">
        <line-label slot="label" :class="elementDict.overseaOp.isRequire ? 'blue' : ''" :label="elementDict.overseaOp.label" />
        <cargo-user-select
          no="overseaOp"
          :method-params="{category:'role',shape:'overseaOp'}"
          :default-value="form.overseaOp||''"
          :static-options="isHC ? null : overseaOpList"
          :merge-load="true"
          @change="p=>{pm.overseaOpChangeHandler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.dcOffice.masterVisible" slot="dcOffice">
        <line-label slot="label" :class="elementDict.dcOffice.isRequire ? 'blue' : ''" :label="elementDict.dcOffice.label" />
        <cargo-office-select
          no="dcOffice"
          :disabled="true"
          :office-id="Number(form.dcOffice)"
          @change="p=>{form.dcOffice=p.value;form.dcDepartment=0}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.dcDepartment.masterVisible" slot="dcDepartment">
        <line-label slot="label" :class="elementDict.dcDepartment.isRequire ? 'blue' : ''" :label="elementDict.dcDepartment.label" />
        <cargo-department-select
          no="dcDepartment"
          :office-id="Number(form.dcOffice)"
          :enables="true"
          :department-id="Number(form.dcDepartment)"
          @change="p=>{form.dcDepartment=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.dc.masterVisible" slot="dc">
        <line-label slot="label" :class="elementDict.dc.isRequire ? 'blue' : ''" :label="elementDict.dc.label" />
        <cargo-user-select
          no="dc"
          :method-params="{officeId:form.opOffice,category:'role',shape:'doc'}"
          :default-value="form.dc||''"
          :merge-load="true"
          @change="p=>{pm.dcChangeHandler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.plannerOffice && elementDict.plannerOffice.masterVisible" slot="plannerOffice">
        <line-label slot="label" :class="elementDict.plannerOffice.isRequire ? 'blue' : ''" :label="elementDict.plannerOffice.label" />
        <cargo-office-select
          no="plannerOffice"
          :disabled="true"
          :office-id="Number(form.plannerOffice)"
          @change="p=>{form.plannerOffice=p.value;form.plannerDepartment=0}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.plannerDepartment && elementDict.plannerDepartment.masterVisible" slot="plannerDepartment">
        <line-label slot="label" :class="elementDict.plannerDepartment.isRequire ? 'blue' : ''" :label="elementDict.plannerDepartment.label" />
        <cargo-department-select
          no="plannerDepartment"
          :office-id="Number(form.plannerOffice)"
          :enables="true"
          :department-id="Number(form.plannerDepartment)"
          @change="p=>{form.plannerDepartment=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.planner.masterVisible" slot="planner">
        <line-label slot="label" :class="elementDict.planner.isRequire ? 'blue' : ''" :label="elementDict.planner.label" />
        <cargo-user-select
          no="planner"
          :method-params="{category:'role',shape:'railwayLine'}"
          :default-value="form.planner||''"
          :merge-load="true"
          @change="p=>{pm.txtPlannerChangeHandler(p)}"
        />
      </el-form-item>
      <el-form-item v-show="isAddUserDefinedRoles && elementDict.userDefinedRoleId1.masterVisible" slot="userDefinedRoleId1">
        <line-label slot="label" :class="elementDict.userDefinedRoleId1.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId1.label" />
        <cargo-user-select
          ref="userDefinedRoleId1"
          no="userDefinedRoleId1"
          :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole1'}"
          :default-value="form.userDefinedRoleId1||''"
          :merge-load="true"
          @change="p=>{pm.userDefinedRoleId1Handler(p)}"
        />
      </el-form-item>
      <el-form-item v-show="isAddUserDefinedRoles && elementDict.userDefinedRoleId2.masterVisible" slot="userDefinedRoleId2">
        <line-label slot="label" :class="elementDict.userDefinedRoleId2.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId2.label" />
        <cargo-user-select
          ref="userDefinedRoleId2"
          no="userDefinedRoleId2"
          :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole2'}"
          :default-value="form.userDefinedRoleId2||''"
          :merge-load="true"
          @change="p=>{pm.userDefinedRoleId2Handler(p)}"
        />
      </el-form-item>
      <!-- <div v-if="elementDict.userDefinedRoleId3 && elementDict.userDefinedRoleId3.masterVisible && $store.getters.enableFrontEndPlugin" slot="userDefinedRoleId3">
        <micro-app
          name="child-user-defined-role-re-master-userDefinedRoleId3"
          :url="$store.getters.frontEndPluginUrl+'/userDefinedRoleItem'"
          router-mode="pure"
          destroy
          @datachange="userDefinedRoleDataChangeUI"
        />
      </div>
      <div v-if="elementDict.userDefinedRoleId4 && elementDict.userDefinedRoleId4.masterVisible && $store.getters.enableFrontEndPlugin" slot="userDefinedRoleId4">
        <micro-app
          name="child-user-defined-role-re-master-userDefinedRoleId4"
          :url="$store.getters.frontEndPluginUrl+'/userDefinedRoleItem'"
          router-mode="pure"
          destroy
          @datachange="userDefinedRoleDataChangeUI"
        />
      </div> -->
      <el-form-item v-if="elementDict.userDefinedRoleId3 && elementDict.userDefinedRoleId3.masterVisible && isAddUserDefinedRoles" slot="userDefinedRoleId3">
        <line-label slot="label" :class="elementDict.userDefinedRoleId3.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId3.label" />
        <cargo-user-select
          ref="userDefinedRoleId3"
          no="userDefinedRoleId3"
          :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole3'}"
          :default-value="form.userDefinedRoleId3||''"
          :merge-load="true"
          @change="p=>{pm.userDefinedRoleId3Handler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedRoleId4 && elementDict.userDefinedRoleId4.masterVisible && isAddUserDefinedRoles" slot="userDefinedRoleId4">
        <line-label slot="label" :class="elementDict.userDefinedRoleId4.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId4.label" />
        <cargo-user-select
          ref="userDefinedRoleId4"
          no="userDefinedRoleId4"
          :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole4'}"
          :default-value="form.userDefinedRoleId4||''"
          :merge-load="true"
          @change="p=>{pm.userDefinedRoleId4Handler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedRoleId5 && elementDict.userDefinedRoleId5.masterVisible && isAddUserDefinedRoles" slot="userDefinedRoleId5">
        <line-label slot="label" :class="elementDict.userDefinedRoleId5.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId5.label" />
        <cargo-user-select
          ref="userDefinedRoleId5"
          no="userDefinedRoleId5"
          :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole5'}"
          :default-value="form.userDefinedRoleId5||''"
          :merge-load="true"
          @change="p=>{pm.userDefinedRoleId5Handler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedRoleId6 && elementDict.userDefinedRoleId6.masterVisible && isAddUserDefinedRoles" slot="userDefinedRoleId6">
        <line-label slot="label" :class="elementDict.userDefinedRoleId6.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId6.label" />
        <cargo-user-select
          ref="userDefinedRoleId6"
          no="userDefinedRoleId6"
          :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole6'}"
          :default-value="form.userDefinedRoleId6||''"
          :merge-load="true"
          @change="p=>{pm.userDefinedRoleId6Handler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedRoleId7 && elementDict.userDefinedRoleId7.masterVisible && isAddUserDefinedRoles" slot="userDefinedRoleId7">
        <line-label slot="label" :class="elementDict.userDefinedRoleId7.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId7.label" />
        <cargo-user-select
          ref="userDefinedRoleId7"
          no="userDefinedRoleId7"
          :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole7'}"
          :default-value="form.userDefinedRoleId7||''"
          :merge-load="true"
          @change="p=>{pm.userDefinedRoleId7Handler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedRoleId8 && elementDict.userDefinedRoleId8.viewable && isAddUserDefinedRoles" slot="userDefinedRoleId8">
        <line-label slot="label" :class="elementDict.userDefinedRoleId8.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId8.label" />
        <cargo-user-select
          ref="userDefinedRoleId8"
          no="userDefinedRoleId8"
          :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole8'}"
          :default-multiple-value="toNumArray(form.userDefinedRoleId8)"
          :multiple="true"
          :merge-load="true"
          :placeholder="readonly ? ' ' : ''"
          @change="p=>{form.userDefinedRoleId8=toTxt(p.value)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.txtWhs.masterVisible" slot="txtWhs">
        <line-label slot="label" :class="elementDict.txtWhs.isRequire ? 'blue' : ''" :label="elementDict.txtWhs.label" />
        <el-input no="txtWhs" :disabled="true" type="textarea" :rows="4" :value="txtWhs" />
      </el-form-item>
      <el-form-item v-if="elementDict.remarks.masterVisible" slot="remarks">
        <line-label slot="label" :class="elementDict.remarks.isRequire ? 'blue' : ''" :label="elementDict.remarks.label" />
        <el-input
          v-model="form.remarks"
          no="remarks"
          type="textarea"
          :rows="4"
          @dblclick.native="showAdvanceTextDialog(elementDict.remarks.label,form.remarks,false,val=>{form.remarks=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedField1.masterVisible" slot="userDefinedField1">
        <line-label slot="label" :class="elementDict.userDefinedField1.isRequire ? 'blue' : ''" :label="elementDict.userDefinedField1.label" />
        <el-input
          v-model="form.userDefinedField1"
          no="userDefinedField1"
          type="textarea"
          :rows="5"
          @dblclick.native="showAdvanceTextDialog(elementDict.userDefinedField1.label,form.userDefinedField1,false,val=>{form.userDefinedField1=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedField2.masterVisible" slot="userDefinedField2">
        <line-label slot="label" :class="elementDict.userDefinedField2.isRequire ? 'blue' : ''" :label="elementDict.userDefinedField2.label" />
        <el-input
          v-model="form.userDefinedField2"
          no="userDefinedField2"
          type="textarea"
          :rows="5"
          @dblclick.native="showAdvanceTextDialog(elementDict.userDefinedField2.label,form.userDefinedField2,false,val=>{form.userDefinedField2=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedField3.masterVisible" slot="userDefinedField3">
        <line-label slot="label" :class="elementDict.userDefinedField3.isRequire ? 'blue' : ''" :label="elementDict.userDefinedField3.label" />
        <el-input
          v-model="form.userDefinedField3"
          no="userDefinedField3"
          type="textarea"
          :rows="5"
          @dblclick.native="showAdvanceTextDialog(elementDict.userDefinedField3.label,form.userDefinedField3,false,val=>{form.userDefinedField3=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedField4.masterVisible" slot="userDefinedField4">
        <line-label slot="label" :class="elementDict.userDefinedField4.isRequire ? 'blue' : ''" :label="elementDict.userDefinedField4.label" />
        <el-input
          v-model="form.userDefinedField4"
          no="userDefinedField4"
          type="textarea"
          :rows="5"
          @dblclick.native="showAdvanceTextDialog(elementDict.userDefinedField4.label,form.userDefinedField4,false,val=>{form.userDefinedField4=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.exportControlledProduct && elementDict.exportControlledProduct.masterVisible" slot="exportControlledProduct">
        <line-label slot="label" :class="elementDict.exportControlledProduct.isRequire ? 'blue' : ''" :label="elementDict.exportControlledProduct.label" />
        <el-select
          v-model="form.exportControlledProduct"
          no="exportControlledProduct"
          :disabled="readonly"
          :placeholder="''"
          :clearable="true"
          size="mini"
        >
          <el-option
            v-for="(item,index) in EXPORT_CONTROLLED_PRODUCT"
            :key="index"
            :label="isZh?item.chineseName:item.englishName"
            :value="item.code"
          />
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('SeaExport.TaxNature')">
        <el-select
          v-model="form.taxNature"
          no="taxNature"
          :placeholder="$t('SeaExport.PleaseSelect')"
          size="mini"
        >
          <el-option
            v-for="(item,index) in TAX_NATURES"
            :key="index"
            :label="isZh?item.chineseName:item.englishName"
            :value="item.code"
          />
        </el-select>&nbsp;
      </el-form-item>
      <el-form-item v-if="elementDict.rateType && elementDict.rateType.masterVisible" slot="rateType">
        <line-label slot="label" :class="elementDict.rateType.isRequire ? 'blue' : ''" :label="elementDict.rateType.label" />
        <el-select
          v-model="form.rateType"
          :disabled="readonly"
          no="rateType"
          clearable
          :placeholder="$t('SeaExport.PleaseSelect')"
          size="mini"
        >
          <el-option
            v-for="(item,index) in rateType"
            :key="index"
            :label="isZh?item.chineseName:item.englishName"
            :value="item.code"
          />
        </el-select>&nbsp;
      </el-form-item>
      <div slot="ticketsInfo" class="form-card-wrapper" style="display:flex;flex-direction: row;width: 100%">
        <div class="section form-column" style="flex:1">
          <span class="title">{{ $t('SeaExport.TicketsInfo') }}</span>
          <div
            style="display:flex;justify-content: flex-start;margin-bottom: 5px;line-height: 28px;"
          >
            <span>{{ $t('SeaExport.TotalTickets') }}:</span>
            <span style="margin-right: 5px;">{{ lclSlaves.length }}</span>
            <div v-show="readonly&&viewSource==='bookingWorkspace'" class="triggers">
              <el-button
                no="NewTickets"
                :disabled="viewSource === 'financeDetail' || viewSource === 'salesDetail'"
                type="primary"
                @click="btnCreateClickHandler"
              >{{ $t('SeaExport.NewTickets') }}</el-button>
              <el-button
                no="EditTickets"
                :disabled="!selectedRow || viewSource === 'financeDetail' || viewSource === 'salesDetail'"
                type="primary"
                @click="btnLcLEditClickHandler"
              >{{ $t('SeaExport.EditTickets') }}</el-button>
              <el-button
                no="AddTickets"
                :disabled="viewSource === 'financeDetail' || viewSource === 'salesDetail'"
                type="primary"
                @click="btnImportLclClickHandler"
              >{{ $t('SeaExport.AddTickets') }}</el-button>
              <el-button
                no="RemoveTickets"
                :disabled="!selectedRow || viewSource === 'financeDetail' || viewSource === 'salesDetail'"
                type="danger"
                @click="pm.btnBatchRemoveClickHandler()"
              >{{ $t('SeaExport.RemoveTickets') }}</el-button>
              <el-button
                v-permission="['button_REBooking_deleteSmallTicket']"
                no="DeleteTickets"
                :disabled="!selectedRow || viewSource === 'financeDetail' || viewSource === 'salesDetail'"
                type="danger"
                @click="btnRemoveClickHandler"
              >{{ $t('SeaExport.DeleteTickets') }}</el-button>
            </div>
          </div>
          <div style="min-height: 200px;flex-direction: column">
            <cargo-ag-grid
              config-module="170003"
              :grid-options="gridOptions"
              :column-defs="columnDefs"
              :row-data="lclSlaves"
              style="height: 300px;"
              @gridReady="params=>{gridApi=params.api}"
            />
          </div>
        </div>
      </div>
    </tab-booking-master-UICustom-layout>
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      no="advanceText"
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <cargo-rich-textarea
        v-model="advanceTextDialog.value"
        :disabled="readonly"
        :warning-count="-1"
        :text-chars="0"
        :auto-uppercase="advanceTextDialog.autoUppercase"
        style="height: 320px;"
      />
      <span slot="footer">
        <el-button
          v-show="isEdit"
          no="confirm"
          type="primary"
          @click="finishAdvanceText"
        >{{ $t('common.btn.confirm') }}</el-button>
        <el-button no="close" @click="advanceTextDialog.visible=false">{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
    <!-- 票数填写弹框 -->
    <el-dialog
      v-el-drag-dialog
      no="ticket"
      :visible.sync="ticketDialog.visible"
      :title="$t('SeaExport.FillInQuantityOfVotes')"
      width="270px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form label-width="50px" label-position="right">
        <el-form-item :label="$t('SeaExport.Number')+'：'">
          <el-input-number
            v-model="ticketDialog.value"
            :precision="0"
            :min="1"
            :max="50"
            :controls="false"
          />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button no="confirm" type="primary" @click="toAddTicket">{{ $t('common.btn.confirm') }}</el-button>
        <el-button no="cancel" type="primary" @click="ticketDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
    <!-- 加入拼箱工作单查询弹窗 -->
    <query-re-lcl-dialog
      :visible.sync="queryRELclDialog.visible"
      :job="form"
      @callback="rows=>{pm.slavedAddedHandler(rows)}"
    />
  </div>
</template>

<script>
import cargoTextarea from '@/components/Cargo/Common/cargoTextarea'
import { TabError } from '@/utils/class/TabError'
import * as CargoSource from '@/class/cargo/model/parameters/CargoSource'
import tabBookingMasterUICustomLayout from '@/views/cargo/v0/RailwayExport/components/booking/tabs/tabBookingMasterUICustomLayout'
import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'
import tabBookingMaster from '@/views/cargo/v0/RailwayExport/components/booking/tabs/tabBookingMaster'
import StrUtils from '@/utils/StrUtils'
import { getObjectByCache } from '@/utils/basicDataCache'
import cargoInput from '@/components/Cargo/Common/cargoInput.vue'
import microApp from '@micro-zoe/micro-app'
import { toNumArray, toTxt } from '@/utils/commonUtil'

export default {
  name: 'ReTabBookingMasterUICustom',
  components: { cargoInput, cargoTextarea, tabBookingMasterUICustomLayout },
  extends: tabBookingMaster,
  data() {
    return {
      elementBlocks: [],
      elementDict: {},
      fieldDict: {},
      superFunction: null, // 用于调用父级的方法
      userDefinedRoleDataUI: { // 子应用自定义岗位
        filedLable: 'CargoMsg.Cargo_userDefinedRole3',
        labelWidth: '133px',
        labelPosition: 'right',
        no: 'userDefinedRoleId3',
        fieldData: this.form ? this.form.userDefinedRoleId3 : null,
        disabled: this.readonly,
        mainClass: 'details-view main-content tabs-container',
        itemClass: '',
        officeId: null,
        category: 'role',
        shape: 'userDefinedRole3',
        staticOptions: null,
        mergeLoad: true
      }
    }
  },
  computed: {
    lob() {
      return this.form.lob
    }
  },
  watch: {
    '$store.getters.currentOfficeId': {
      handler() {
        this.loadPageConfig()
      }
    },
    lob() {
      this.loadPageConfig()
    },
    'form.exportControlledProduct': {
      immediate: true,
      handler(val) {
        if (val === 0) {
          this.form.exportControlledProduct = ''
        }
      }
    }
  },
  created() {
    this.loadPageConfig()
  },
  methods: {
    toTxt,
    toNumArray,
    async onShow(row, isRefresh) {
      this.superFunction = this.$options.extends.methods.onShow
      await this.superFunction(row, isRefresh)
    },
    loadPageConfig() {
      if (this.previewConfig) {
        this.elementBlocks = this.previewConfig.elementBlocks
        this.elementDict = this.previewConfig.elementDict
        this.fieldDict = this.previewConfig.fieldDict
      } else {
        const pageType = this.lob === 'RE' ? UICustomConstants.RAILWAY_BOOKING_RE_BASIC : UICustomConstants.RAILWAY_BOOKING_RI_BASIC
        const pageConfig = UICustomUtil.getPageConfig(pageType, this.$store.getters.currentOfficeId)
        this.elementBlocks = pageConfig.elementBlocks
        this.elementDict = pageConfig.elementDict
        this.fieldDict = pageConfig.fieldDict
      }
    },
    async validateForm() {
      const form = this.form
      for (const key in this.fieldDict) {
        const field = this.fieldDict[key]
        if (field.masterVisible && field.isRequire) {
          if (key === 'agentRefNo') {
            if (form.cargoSource !== CargoSource.NC_CARGO_SOURCE.code) {
              continue
            }
          }
          if (key === 'secondaryCustomJobType') {
            if (!(this.form.customJobType && this.secondaryCustomJobTypeList.length > 0)) {
              continue
            }
          }
          if (key === 'projectName' || key === 'projectBatch') {
            if (!this.openProjectConfig) {
              continue
            }
          }
          if (key === 'satisfiedRequests' || key === 'operationTips' || key === 'surchargeTerms' || key === 'boxOneWay' || key === 'warehouseNo') {
            continue
          }
          if (key === 'userDefinedRoleId1' || key === 'userDefinedRoleId2') {
            if (!this.isAddUserDefinedRoles) {
              continue
            }
          }
          if (key === 'shipperLine1') {
            let shipperLine = ''
            for (let i = 1; i <= 7; ++i) {
              shipperLine += form['shipperLine' + i]
            }
            if (StrUtils.isEmpty(shipperLine)) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'tabBookingMaster')
            }
            continue
          }
          if (key === 'consigneeLine1') {
            let consigneeLine = ''
            for (let i = 1; i <= 7; ++i) {
              consigneeLine += form['consigneeLine' + i]
            }
            if (StrUtils.isEmpty(consigneeLine)) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'tabBookingMaster')
            }
            continue
          }
          if (key === 'notifyLine1') {
            let notifyLine = ''
            for (let i = 1; i <= 7; ++i) {
              notifyLine += form['notifyLine' + i]
            }
            if (StrUtils.isEmpty(notifyLine)) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'tabBookingMaster')
            }
            continue
          }
          if (key.startsWith('shipperLine') || key.startsWith('consigneeLine') || key.startsWith('notifyLine')) {
            continue
          }
          if (key === 'transfer') {
            if (form.transfer && StrUtils.isEmpty(form.transferStation)) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'tabBookingMaster')
            }
          } else if (key === 'designationAgent') {
            if (form.cargoSource === CargoSource.NC_CARGO_SOURCE.code && !form.designationAgent) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'tabBookingMaster')
            }
          } else if (key === 'customClaim') {
            const obj = getObjectByCache(this.selectTypeNames.basic_data_CustomsMode, 'serialNum', form.customClaim)
            if (!obj) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'tabBookingMaster')
            }
          } else if (key === 'taxNature') {
            if (form[key] === '' || form[key] === null) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'tabBookingFCL')
            }
          } else {
            if (typeof form[key] !== 'boolean' && StrUtils.isEmpty(form[key])) {
              const label = this.elementDict[key] ? this.elementDict[key].label : field.label
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [label]), 'tabBookingMaster')
            }
          }
        }
      }
      if (this.elementDict.seaEq && this.elementDict.seaEq.masterVisible && this.elementDict.seaEq.isRequire) {
        if (form.containerLoadType === 'FCL' || form.containerLoadType === 'BB') {
          if (!this.seaEqList || this.seaEqList.length === 0) {
            throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.seaEq.label]), 'tabBookingMaster')
          }
          for (const seaEq of this.seaEqList) {
            if (!seaEq.eqQuantity) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.$t('SeaExport.ContainerAmount')]), 'tabBookingMaster')
            }
          }
        }
      }
      if (this.elementDict.warehouseCmp && this.elementDict.warehouseCmp.masterVisible && this.elementDict.warehouseCmp.isRequire) {
        if (!this.form.warehouseCmp) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.warehouseCmp.label]), 'tabBookingMaster')
        }
      }
      if (this.elementDict.warehouseName && this.elementDict.warehouseName.masterVisible && this.elementDict.warehouseName.isRequire && this.openWarehouse && this.warehouseEabled && this.form.warehouseCmp) {
        if (StrUtils.isEmpty(this.form.warehouseName)) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.warehouseName.label]), 'tabBookingMaster')
        }
      }
      if (this.elementDict.carryingCmp && this.elementDict.carryingCmp.masterVisible && this.elementDict.carryingCmp.isRequire && this.form.landTransportation) {
        if (!this.form.carryingCmp) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.carryingCmp.label]), 'tabBookingMaster')
        }
      }
      if (this.elementDict.quantityConsignActual && this.elementDict.quantityConsignActual.masterVisible && this.elementDict.quantityConsignActual.isRequire) {
        if (!this.form.quantityContract || !this.form.quantityActual) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.quantityConsignActual.label]), 'tabBookingMaster')
        }
      }
      if (this.elementDict.weightConsignActual && this.elementDict.weightConsignActual.masterVisible && this.elementDict.weightConsignActual.isRequire) {
        if (!this.form.weightContract || !this.form.weightActual) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.weightConsignActual.label]), 'tabBookingMaster')
        }
      }
      if (this.elementDict.cubageConsignActual && this.elementDict.cubageConsignActual.masterVisible && this.elementDict.cubageConsignActual.isRequire) {
        if (!this.form.cubageContract || !this.form.cubageActual) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.cubageConsignActual.label]), 'tabBookingMaster')
        }
      }
      if (this.elementDict.txtSalesOffice && this.elementDict.txtSalesOffice.masterVisible && this.elementDict.txtSalesOffice.isRequire) {
        if (StrUtils.isEmpty(this.txtSalesOffice)) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.txtSalesOffice.label]), 'tabBookingMaster')
        }
      }
      if (this.elementDict.txtWhs && this.elementDict.txtWhs.masterVisible && this.elementDict.txtWhs.isRequire) {
        if (StrUtils.isEmpty(this.txtWhs)) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.txtWhs.label]), 'tabBookingMaster')
        }
      }
      this.superFunction = this.$options.extends.methods.validateForm
      return await this.superFunction()
    },
    setUserDefinedRoleDataUI() {
      return
      // userDefinedRoleId3
      const userDefinedRoleData3 = { ...this.userDefinedRoleDataUI }
      userDefinedRoleData3.fieldData = this.form.userDefinedRoleId3 || ''
      userDefinedRoleData3.disabled = this.readonly
      userDefinedRoleData3.filedLable = 'CargoMsg.Cargo_userDefinedRole3'
      userDefinedRoleData3.no = 'userDefinedRoleId3'
      userDefinedRoleData3.officeId = this.$store.getters.currentOfficeId
      userDefinedRoleData3.category = 'role'
      userDefinedRoleData3.shape = 'userDefinedRole3'
      userDefinedRoleData3.staticOptions = null
      userDefinedRoleData3.mergeLoad = true
      console.log('主应用发送UserDefinedRole:', userDefinedRoleData3)
      microApp.forceSetData('child-user-defined-role-re-master-userDefinedRoleId3', userDefinedRoleData3)
      // userDefinedRoleId4
      const userDefinedRoleData4 = { ...this.userDefinedRoleDataUI }
      userDefinedRoleData4.fieldData = this.form.userDefinedRoleId4 || ''
      userDefinedRoleData4.disabled = this.readonly
      userDefinedRoleData4.filedLable = 'CargoMsg.Cargo_userDefinedRole4'
      userDefinedRoleData4.no = 'userDefinedRoleId4'
      userDefinedRoleData4.officeId = this.$store.getters.currentOfficeId
      userDefinedRoleData4.category = 'role'
      userDefinedRoleData4.shape = 'userDefinedRole4'
      userDefinedRoleData4.staticOptions = null
      userDefinedRoleData4.mergeLoad = true
      console.log('主应用发送UserDefinedRole:', userDefinedRoleData4)
      microApp.forceSetData('child-user-defined-role-re-master-userDefinedRoleId4', userDefinedRoleData4)
    },
    userDefinedRoleDataChangeUI(e) {
      console.log('主应用获取UserDefinedRole:', e.detail.data)
      if (e.detail.data) {
        if (e.detail.data.type === 'created') {
          this.setUserDefinedRoleDataUI()
        } else {
          if (e.detail.data.no === 'userDefinedRoleId3') {
            this.form.userDefinedRoleId3 = e.detail.data.fieldData
            this.pm.userDefinedRoleId3Handler(this.form.userDefinedRoleId3)
          } else if (e.detail.data.no === 'userDefinedRoleId4') {
            this.form.userDefinedRoleId4 = e.detail.data.fieldData
            this.pm.userDefinedRoleId4Handler(this.form.userDefinedRoleId4)
          }
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .poNoClass {
    /deep/ .el-input.is-disabled .el-input__inner {
      color: red !important;
    }
  }
  /deep/ .also-notify {
    width: 310px;
    .el-textarea__inner {
      height: 230px;
    }
  }
</style>
